export default __webpack_public_path__ + "static/media/image_watermark.30d631c9.svg";